<template>
  <div>
    <vx-card class="filter-section">
      <div class=" filter-section">
        <vs-divider position="center"><h5>Search Bookings </h5></vs-divider>


        <!-- Date Filter -->
        <div class="mt-4 filter-row">
          <label class="text-sm">Date :</label>
          <datepicker
            class="mb-4"
            label="Date"
            placeholder="Select Date"
            v-model="dateFilter"
          >
          </datepicker>
        </div>

        <!-- Filter Select -->
        <div class="filter-row">
          <label class="text-sm">Filter By :</label>
           <select class="vs__dropdown-toggle v-select" v-model="selectedTextFilter">
            <option class="" disabled value="">Select</option>
            <option style="font-family:'Montserrat'" value="bookingId">Booking ID</option>
            <option value="paymentRef">Payment Reference</option>
          </select>
          <!-- <v-select
            v-model="selectedTextFilter"
            :clearable="true"
            :options="filterOptions"
          /> -->
        </div>

        <!-- Conditional Text Input -->
        <div class="w-auto filter-row" v-if="selectedTextFilter">
          <label class="text-sm">
            Enter
            {{
              selectedTextFilter === "bookingId"
                ? "Booking ID"
                : "Payment Reference"
            }} :
          </label>
          <vs-input
          class="w-auto"
            type="text"
            v-model="textFilterValue"
            :placeholder="
              selectedTextFilter === 'bookingId'
                ? 'e.g. BKG12345'
                : 'e.g. PAY12345'
            "
          />
        </div>

        <!-- Buttons -->
        <div class="filter-row">
          <vs-button
            color="primary"
            @click="searchResults"
            :disabled="!dateFilter && (!selectedTextFilter || !textFilterValue)"
          >
            Search
          </vs-button>
          <vs-button color="danger" @click="clearFilter" class="clear-btn"
            >Clear Filter</vs-button
          >
        </div>

        <!-- Loading -->
        <div v-if="loading"><p>Loading...</p></div>
      </div>
      </vx-card>
      <vs-divider></vs-divider>
      <vx-card>
      <!-- Single Result -->
      <div v-if="payment && !payments.length">
        <h4>Single Booking Found:</h4>
        <vs-table :data="payment">
          <template slot="thead">
            <vs-th>API BookingID</vs-th>
            <vs-th>Date</vs-th>
            <vs-th>Receipt ID</vs-th>
            <vs-th>Payment Reference</vs-th>
            <vs-th class="w-4">Card Payment Status</vs-th>
            <vs-th>Amount</vs-th>
            <vs-th>Actions</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ tr.api_booking_id }}</vs-td>
              <vs-td>{{ tr.payment.created_at }}</vs-td>
              <vs-td>{{ tr.payment.receipt_id }}</vs-td>

              <vs-td>{{ tr.payment.payment_reference }}</vs-td>
              <vs-td>
                <vx-tooltip
                  v-if="tr.payment.status == 'pending'"
                  :text="tr.payment.status"
                  color="danger"
                  position="top"
                  delay=".3s"
                >
                  <feather-icon
                    icon="ZapIcon"
                    :svgClasses="[
                      { 'text-danger': true },
                      'h-5 w-5 stroke-current mt-1',
                    ]"
                    class=""
                  />
                </vx-tooltip>
                <vx-tooltip
                  v-if="tr.payment.status == 'paid'"
                  :text="tr.payment.status"
                  color="success"
                  position="top"
                  delay=".3s"
                >
                  <feather-icon
                    icon="CheckCircleIcon"
                    :svgClasses="[
                      { 'text-success': true },
                      'h-5 w-5 stroke-current mt-1',
                    ]"
                    class=""
                  />
                </vx-tooltip>
                <vx-tooltip
                  v-if="tr.payment.status == 'refunded'"
                  :text="tr.payment.status"
                  color="warning"
                  position="top"
                  delay=".3s"
                >
                  <feather-icon
                    icon="RefreshCcwIcon"
                    :svgClasses="[
                      { 'text-warning': true },
                      'h-5 w-5 stroke-current mt-1',
                    ]"
                    class=""
                  />
                </vx-tooltip>
                <vx-tooltip
                  v-if="tr.payment.status == 'cancelled'"
                  :text="tr.payment.status"
                  color="error"
                  position="top"
                  delay=".3s"
                >
                  <feather-icon
                    icon="XCircleIcon"
                    :svgClasses="[
                      { 'text-error': true },
                      'h-5 w-5 stroke-current mt-1',
                    ]"
                    class=""
                  />
                </vx-tooltip>
              </vs-td>

              <vs-td>{{ tr.payment.amount }}GBP</vs-td>
              <vs-td>
                <vs-button
                  v-if="
                    refundAllowed &&
                    tr.payment.status == 'paid' &&
                    tr.payment.receipt_id
                  "
                  color="warning"
                  class=""
                  size="small"
                  @click.stop="openAlert(indextr)"
                >
                  Refund
                </vs-button>
                <vs-button
                  v-if="tr.payment.status == 'paid'"
                  color="purple"
                  class="ml-2"
                  size="small"
                  @click.stop="openEmailAlert(indextr,'single')"
                >
                  Get Receipt
                </vs-button>
                <vs-button
                  v-else-if="tr.payment.status == 'refunded'"
                  class=""
                  color="green"
                  size="small"
                >
                  Refunded
                </vs-button>
                <vs-button
                  v-else-if="
                    (tr.payment.status == 'pending' ||
                      tr.payment.status == 'cancelled') &&
                    !tr.payment.receipt_id
                  "
                  disabled
                  class="pl-3 pr-3"
                  color="grey"
                  size="small"
                >
                  No Receipt ID
                </vs-button>
                <vs-button
                  v-if="
                    (tr.payment.status == 'pending' ||
                      tr.payment.status == 'cancelled') &&
                    !tr.payment.receipt_id
                  "
                  color="primary"
                  class="ml-1 pl-2 pr-2"
                  size="small"
                  @click.stop="openSMSAlert(indextr)"
                >
                  Resend Payment link
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>

      <!-- Paginated List -->
      <div v-if="payments.length">
        <h4>Bookings:</h4>
        <vs-table :data="payments">
          <template slot="thead">
            <vs-th>API BookingID</vs-th>
            <vs-th>Date</vs-th>
            <vs-th>Receipt ID</vs-th>
            <vs-th>Payment Reference</vs-th>
            <vs-th class="w-4">Card Payment Status</vs-th>
            <vs-th>Amount</vs-th>
            <vs-th>Actions</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ tr.api_booking_id }}</vs-td>
              <vs-td>{{ tr.payment.created_at }}</vs-td>
              <vs-td>{{ tr.payment.receipt_id }}</vs-td>

              <vs-td>{{ tr.payment.payment_reference }}</vs-td>
              <vs-td>
                <vx-tooltip
                  v-if="tr.payment.status == 'pending'"
                  :text="tr.payment.status"
                  color="danger"
                  position="top"
                  delay=".3s"
                >
                  <feather-icon
                    icon="ZapIcon"
                    :svgClasses="[
                      { 'text-danger': true },
                      'h-5 w-5 stroke-current mt-1',
                    ]"
                    class=""
                  />
                </vx-tooltip>
                <vx-tooltip
                  v-if="tr.payment.status == 'paid'"
                  :text="tr.payment.status"
                  color="success"
                  position="top"
                  delay=".3s"
                >
                  <feather-icon
                    icon="CheckCircleIcon"
                    :svgClasses="[
                      { 'text-success': true },
                      'h-5 w-5 stroke-current mt-1',
                    ]"
                    class=""
                  />
                </vx-tooltip>
                <vx-tooltip
                  v-if="tr.payment.status == 'refunded'"
                  :text="tr.payment.status"
                  color="warning"
                  position="top"
                  delay=".3s"
                >
                  <feather-icon
                    icon="RefreshCcwIcon"
                    :svgClasses="[
                      { 'text-warning': true },
                      'h-5 w-5 stroke-current mt-1',
                    ]"
                    class=""
                  />
                </vx-tooltip>
                <vx-tooltip
                  v-if="tr.payment.status == 'cancelled'"
                  :text="tr.payment.status"
                  color="error"
                  position="top"
                  delay=".3s"
                >
                  <feather-icon
                    icon="XCircleIcon"
                    :svgClasses="[
                      { 'text-error': true },
                      'h-5 w-5 stroke-current mt-1',
                    ]"
                    class=""
                  />
                </vx-tooltip>
              </vs-td>

              <vs-td>{{ tr.payment.amount }}GBP</vs-td>
              <vs-td>
                <vs-button
                  v-if="
                    refundAllowed &&
                    tr.payment.status == 'paid' &&
                    tr.payment.receipt_id
                  "
                  color="warning"
                  class=""
                  size="small"
                  @click.stop="openAlert(indextr)"
                >
                  Refund
                </vs-button>
                <vs-button
                  v-if="tr.payment.status == 'paid'"
                  color="purple"
                  class="ml-2"
                  size="small"
                  @click.stop="openEmailAlert(indextr)"
                >
                  Get Receipt
                </vs-button>
                <vs-button
                  v-else-if="tr.payment.status == 'refunded'"
                  class=""
                  color="green"
                  size="small"
                >
                  Refunded
                </vs-button>
                <vs-button
                  v-else-if="
                    (tr.payment.status == 'pending' ||
                      tr.payment.status == 'cancelled') &&
                    !tr.payment.receipt_id
                  "
                  disabled
                  class="pl-3 pr-3"
                  color="grey"
                  size="small"
                >
                  No Receipt ID
                </vs-button>
                <vs-button
                  v-if="
                    (tr.payment.status == 'pending' ||
                      tr.payment.status == 'cancelled') &&
                    !tr.payment.receipt_id
                  "
                  color="primary"
                  class="ml-1 pl-2 pr-2"
                  size="small"
                  @click.stop="openSMSAlert(indextr)"
                >
                  Resend Payment link
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <!-- Simple Pagination -->
        <div class="pagination">
          <button
            :disabled="currentPage <= 1"
            @click="changePage(currentPage - 1)"
          >
            Prev
          </button>
          <span>Page {{ currentPage }}</span>
          <button
            :disabled="!hasMorePages"
            @click="changePage(currentPage + 1)"
          >
            Next
          </button>
        </div>
      </div>

      <!-- No Data -->
      <div v-if="!loading && !payment && !payments.length && searched">
        <p>No records found.</p>
      </div>
    </vx-card>
    <vs-prompt
      title="SMS payment link to customer"
      accept-text="Send"
      @accept="send_sms"
      :active.sync="smsPrompt"
    >
      <div class="con-exemple-prompt">
        Enter the phone number
        <vs-input
          class="w-full mt-2"
          placeholder="+447*******"
          v-model="customer_telephone"
        />
      </div>
    </vs-prompt>
    <vs-prompt
      title="Email to customer"
      accept-text="Send"
      @accept="send_email"
      :active.sync="emailPrompt"
    >
      <div class="con-exemple-prompt">
        Enter email
        <vs-input
          class="w-full mt-2"
          placeholder="john@smith.com"
          v-model="customer_email"
        />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { _sms_payments } from "@/services/Company";

import { _refundPayment, _getReceipt } from "@/services/Payment";
import { _send_sms } from "@/services/Smspay";
import vSelect from "vue-select";

import Datepicker from "vuejs-datepicker";

export default {
  components: {
    vSelect,
    Datepicker,
  },
  data() {
    return {
      dateFilter: new Date(),
      selectedTextFilter: "",
      textFilterValue: "",
      payment: null,
      payments: [],
      currentPage: 1,
      currentIndex: -1,

      hasMorePages: false,
      loading: false,
      searched: false,
      current_company: this.$store.state.company.companyID,
      filterOptions: [
        { label: "Booking ID", value: "bookingId" },
        { label: "Payment Reference", value: "paymentRef" },
      ],
      emailPrompt: false,
      customer_email: "",
      smsPrompt: false,
      customer_telephone: "",
      resultSet : null
    };
  },
  watch: {
    selectedTextFilter() {
      this.textFilterValue = "";
    },
  },
  computed: {
    refundAllowed() {
      const localPermission = this.$store.state.AppActiveUser.permissions;
      if (
        Object.keys(localPermission).length === 0 &&
        localPermission.constructor === Object
      )
        return true;
      else {
        if (localPermission.some((p) => p.path.includes("/refund"))) {
          return true;
        }
        return false;
      }
    },
  },
  methods: {
    searchResults(page = 1) {
      if (typeof page !== "number") page = 1;
      this.loading = true;
      this.searched = true;
      this.payment = null;
      this.payments = [];

      this.currentPage = page; // ✅ SET the current page
      const payload = {
        page: page, // ✅ Use the passed page number
        filterType: this.selectedTextFilter || "none",
      };

      if (this.textFilterValue) {
        payload.value = this.textFilterValue;
      }

      if (this.dateFilter) {
          let dateObj = new Date(this.dateFilter);
          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          const day = String(dateObj.getDate()).padStart(2, '0');
          payload.date = `${year}-${month}-${day}`;
        }

      _sms_payments(this.current_company, payload, this.currentPage)
        .then((res) => {
          if (res.data.obj.payment) {
            this.payment = res.data.obj.payment;
            this.hasMorePages = false;
            this.resultSet = 'single';
          } else if (res.data.obj.payments) {
            this.resultSet = 'list'
            this.payments = res.data.obj.payments.data || res.data.obj.payments;
            this.hasMorePages =
              res.data.obj.payments.current_page <
              res.data.obj.payments.last_page;
          }
        })
        .catch((err) => {
          console.error("Search error:", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changePage(page) {
      this.searchResults(page); // ✅ properly pass page number
    },
    clearFilter() {
      this.selectedTextFilter = "";
      this.textFilterValue = "";
      // Optional:
      this.dateFilter = "";
      this.payment = null;
      this.payments = [];
      this.currentPage = 1;
      this.hasMorePages = false;
      this.searched = false;
      this.resultSet = null;

    },
    openAlert(rowIndex) {
      this.currentIndex = rowIndex;
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Refund Request`,
        text: "Do you really want to make a refund of this payment?",
        accept: this.doRefund,
        acceptText: "Do Refund",
      });
    },
    openEmailAlert(rowIndex) {
      this.currentIndex = rowIndex;
      if(this.resultSet == 'single')
        this.customer_email = this.payment[rowIndex].customer_email;
      else
        this.customer_email = this.payments[rowIndex].customer_email;

      this.emailPrompt = true;
    },
    openSMSAlert(rowIndex) {
      this.currentIndex = rowIndex;
       if(this.resultSet == 'single')
          this.customer_telephone = this.payment[rowIndex].customer_telephone;
        else
          this.customer_telephone = this.payments[rowIndex].customer_telephone;

      this.smsPrompt = true;
    },
    send_email() {
      if (!this.customer_email)
        return alert("Please enter valid email to get receipt");

      const pr = (this.resultSet == 'single')
                ? this.payment[this.currentIndex].payment.reference_number
                : this.payments[this.currentIndex].payment.reference_number;
      _getReceipt(
        { email: this.customer_email },
        pr
      )
        .then(
          (res) => {
            console.log(res.data);
            alert("email has been sent to your given address");
            this.customer_email = "";
          },
          (error) => {
            this.handleError(error);
          }
        )
        .catch((error) => {
          this.handleCatch(error);
        });
    },
    send_sms() {
      let ride = (this.resultSet == 'single')
                ? this.payment[this.currentIndex]
                : this.payments[this.currentIndex];

      const message =
        "Hello Your ride from " +
        ride.pickup +
        " to " +
        ride.destination +
        " at " +
        ride.order_time +
        " has been booked. Booking Ref:" +
        ride.api_booking_id +
        ". Download the App now: http://bit.ly/2k1PVG0 Would you like a fixed price and pay by card click the link ";
      let data = {
        phonenumber: this.customer_telephone,
        message: message,
        bookingId: ride.api_booking_id,
        generateLink: true,
      };
      this.$vs.loading();
      _send_sms(data)
        .then(
          (res) => {
            this.$vs.notify({
              text: "SMS sent successfully",
              iconPack: "feather",
              icon: "icon-check-circle",
              color: "success",
            });
          },
          (error) => {
            this.handleError(error);
          }
        )
        .catch((error) => {
          this.handleCatch(error);
        })
        .finally(() => this.$vs.loading.close());
    },
    doRefund() {
      let rowIndex = this.currentIndex;
      let obj = (this.resultSet == 'single')
                ? this.payment[rowIndex]
                : this.payments[rowIndex];
      let payment = obj.payment;

      _refundPayment(payment).then(
        (res) => {
          if (this.resultSet == 'single') {
            this.payment[rowIndex].payment.status = "refunded";
          }
          else {
            this.payments[rowIndex].payment.status = "refunded";
          }
          this.$vs.notify({
            title: "Refund",
            text: res.data.message,
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
          });
        },
        (error) => {
          this.$vs.notify({
            title: "Refund",
            text: error.response.data.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
            time: 5000,
          });
        }
      );
    },
    handleError(error) {
      if (error.response.status == 422) {
        this.$vs.notify({
          title: "validation",
          text: "Validation Error",
          iconPack: "feather",
          icon: "icon-cross-circle",
          color: "danger",
        });
      } else {
        let errMsg = "";
        let errTitle = "";
        if (error.response.data.responseTitle) {
          errTitle = error.response.data.responseTitle;
          errMsg = error.response.data.responseMessage;
        } else {
          errTitle = "Failed";
          errMsg = error.response.data.message;
        }
        this.$vs.notify({
          title: errTitle,
          text: errMsg,
          iconPack: "feather",
          icon: "icon-cross-circle",
          color: "danger",
        });
      }
    },
    handleCatch(error) {
      this.$vs.notify({
        text: error.message,
        iconPack: "feather",
        icon: "icon-cross-circle",
        color: "danger",
      });
    },
  },
};
</script>

<style scoped>
.filter-section {
  max-width: 600px;
  margin: 20px auto;
}
.filter-row {
  margin-bottom: 15px;
}
label {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
}
input,
select {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}
button {
  padding: 10px 16px;
  background-color: #2563eb;
  color: white;
  border: none;
  cursor: pointer;
}
button:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}
.clear-btn {
  margin-left: 10px;
  background-color: #f87171;
}
.pagination {
  margin-top: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
